'use strict';

module.exports = bail;

function bail(err) {
  if (err) {
    throw err;
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/bail/index.js
// module id = 141
// module chunks = 96961042003272 139266963665775